const invoiceListContainer = "flex-1 min-h-0 overflow-y-auto rounded-xl border border-border/60 bg-card mb-4 shadow-sm";

const listHeader = "flex items-center justify-between px-4 py-3 border-b border-border/60 bg-muted/30 shrink-0";

const selectAllBtn = "text-muted-foreground hover:text-foreground h-7 gap-1";

const listBody = "flex-1 min-h-0 overflow-y-auto";

const processingState = "flex items-center gap-2 mb-4 shrink-0 px-1";

const cancelBtn = "ml-auto text-muted-foreground hover:text-destructive";

const payBtn = "w-full md:w-auto mb-4 h-11 text-base";

const icon = "mr-2 h-4 w-4";

const loaderSpin = "h-4 w-4 animate-spin text-muted-foreground";

export { invoiceListContainer, listHeader, selectAllBtn, listBody, processingState, cancelBtn, payBtn, icon, loaderSpin };
